// ABOUTME: The canoe's rigging lines carried straight up past the asset's top edge to the top of the viewport.
// ABOUTME: An svg that rides inside the rolling deck sprite, so the lines roll with the canoe.

import { CROSSING_DECK_RIGGING, CROSSING_DECK_RIGGING_STRONG } from '../../../theme/crossingTokens';
import { riggingHeight } from './horizon';

const ASSET_WIDTH = 1024;
const ASSET_TOP_Y = -25; // the asset's viewBox top; an <img> clips everything above it
const ASSET_FAR_Y = -320; // where the asset's own rigging lines end

// The asset's two rigging groups: the first four (stroke rgba(252,248,241,0.55), width 1.6, round caps) run from y 465,
// the last two (stroke rgba(252,248,241,0.6), width 1.8) from y 650. x1/y1 -> x2/ASSET_FAR_Y is each line as the asset draws it.
const LINES = [
  { x1: 202, y1: 465, x2: 305.5, stroke: CROSSING_DECK_RIGGING, width: 1.6, cap: 'round' },
  { x1: 275, y1: 465, x2: 329.4, stroke: CROSSING_DECK_RIGGING, width: 1.6, cap: 'round' },
  { x1: 822, y1: 465, x2: 718.5, stroke: CROSSING_DECK_RIGGING, width: 1.6, cap: 'round' },
  { x1: 749, y1: 465, x2: 694.6, stroke: CROSSING_DECK_RIGGING, width: 1.6, cap: 'round' },
  { x1: 70, y1: 650, x2: 219, stroke: CROSSING_DECK_RIGGING_STRONG, width: 1.8, cap: 'butt' },
  { x1: 954, y1: 650, x2: 805, stroke: CROSSING_DECK_RIGGING_STRONG, width: 1.8, cap: 'butt' },
] as const;

interface DeckRiggingProps {
  frameH: number;
  scale: number;
}

export default function DeckRigging({ frameH, scale }: DeckRiggingProps) {
  const height = riggingHeight(frameH, scale);
  const units = height / scale; // the svg's height in asset units
  return (
    <svg
      data-testid="deck-rigging"
      aria-hidden="true"
      focusable="false"
      viewBox={`0 ${ASSET_TOP_Y - units} ${ASSET_WIDTH} ${units}`}
      preserveAspectRatio="none"
      style={{ position: 'absolute', bottom: '100%', left: 0, width: '100%', height: `${height}px`, overflow: 'hidden', pointerEvents: 'none' }}
    >
      {LINES.map(({ x1, y1, x2, stroke, width, cap }) => {
        const perUnit = (x2 - x1) / (y1 - ASSET_FAR_Y); // x moves this far per unit up
        const xAtTop = x1 + perUnit * (y1 - ASSET_TOP_Y);
        return (
          <line
            key={x1}
            x1={xAtTop}
            y1={ASSET_TOP_Y + 1}
            x2={xAtTop + perUnit * (units + 1)}
            y2={ASSET_TOP_Y - units}
            stroke={stroke}
            strokeWidth={width}
            strokeLinecap={cap}
          />
        );
      })}
    </svg>
  );
}
